/** LuluPainter — 2D pix + hat silhouette. */
export const LuluPainter = {
  paint(ctx, _pos, radius, _entity) {
    ctx.beginPath();
    ctx.arc(0, 0, radius * 0.75, 0, Math.PI * 2);
    ctx.fillStyle = '#7c3aed';
    ctx.fill();

    ctx.beginPath();
    ctx.arc(0, -radius * 0.5, radius * 0.4, 0, Math.PI * 2);
    ctx.fillStyle = '#a78bfa';
    ctx.fill();

    ctx.beginPath();
    ctx.moveTo(-radius * 0.35, -radius * 0.85);
    ctx.lineTo(0, -radius * 1.35);
    ctx.lineTo(radius * 0.35, -radius * 0.85);
    ctx.closePath();
    ctx.fillStyle = '#5b21b6';
    ctx.fill();

    ctx.beginPath();
    ctx.arc(radius * 0.7, -radius * 0.2, radius * 0.2, 0, Math.PI * 2);
    ctx.fillStyle = '#ddd6fe';
    ctx.fill();
  }
};
